import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const PlayIcon = ({ size, deg, color }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg, color: color },
    React.createElement("path", { d: "M5 5v10.518a1 1 0 001.504.863l9.002-5.285a1 1 0 00-.003-1.728L6.5 4.135A.998.998 0 005 5z" })));
export const Play = iconGenerator(PlayIcon);
//# sourceMappingURL=Play.js.map